import { FieldTypes } from 'data';
import moment from 'moment';
import { useLocation } from 'react-router-dom';
import { GUIDES, INDEX } from 'router/routes';
import { NGA_STATE } from './constants';

export const querystring = (search = window.location.search) => {
  const searchParams = new URLSearchParams(search);
  return searchParams;
};
export const getRandomArrayItem = (arr) => {
  const randomIndex = Math.floor(Math.random() * arr.length);
  return arr[randomIndex];
};

export const getFirstLetters = (word) => {
  const wordSplit = word.split(' ');
  return wordSplit.map((item) => item.charAt(0));
};

export const truncate = (text = '', count) => {
  if (!text) return text;
  if (count < text.length) return `${text.substr(0, count)}...`;
  return text;
};

export const formatCurrency = (num) =>
  typeof num === 'number'
    ? Math.sign(num) === -1
      ? `-₦${num
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
          .slice(1)}`
      : `₦${num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}`
    : `-`;

export const formatWithCommas = (num) => {
  if (num !== 0 && !num) {
    return '';
  }
  let value = num;
  if (typeof value === 'string') {
    value = parseFloat(num);
  }
  return value.toLocaleString();
};

export const formatText = (text) => text || `-`;

export const truncateText = (input, maxLength) =>
  input.length > maxLength ? `${input.substring(0, maxLength)}...` : input;

export const capitalizeText = (text = '') =>
  [...text].map((char, index) => (index ? char : char.toUpperCase())).join('');

export const formatCashWithAbbreviation = (n) => {
  if (n < 1e3) return n;
  if (n >= 1e3 && n < 1e6) return `${+(n / 1e3).toFixed(1)}K`;
  if (n >= 1e6 && n < 1e9) return `${+(n / 1e6).toFixed(1)}M`;
  if (n >= 1e9 && n < 1e12) return `${+(n / 1e9).toFixed(1)}B`;
  if (n >= 1e12) return `${+(n / 1e12).toFixed(1)}T`;
};

export const formatNumWithCommas = (num) => {
  let str = parseInt(num).toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 3,
  });
  str = str.replace(/\./, '.');
  str = str.replace(/,/g, ',');
  return str;
};

export const getViewPortDimension = () => {
  const width = Math.max(
    document.documentElement.clientWidth || 0,
    window.innerWidth || 0,
  );
  const height = Math.max(
    document.documentElement.clientHeight || 0,
    window.innerHeight || 0,
  );
  return {
    width,
    height,
  };
};

export const generateField = (type, key) => {
  switch (type) {
    case FieldTypes.SHORT_TEXT:
      return {
        name: 'Single Text',
        hint: 'Some text',
        type: FieldTypes.SHORT_TEXT,
        required: false,
        lookupRequired: false,
        key,
        options: [],
      };
    case FieldTypes.LONG_TEXT:
      return {
        name: 'Long Text',
        hint: 'Some text',
        type: FieldTypes.LONG_TEXT,
        required: false,
        lookupRequired: false,
        key,
        options: [],
      };
    case FieldTypes.EMAIL:
      return {
        name: 'Email',
        hint: 'Your email Address',
        type: FieldTypes.LONG_TEXT,
        required: false,
        lookupRequired: false,
        key,
        options: [],
      };
    case FieldTypes.NUMBER:
      return {
        name: 'Number',
        hint: '123456789',
        type: FieldTypes.NUMBER,
        selected: FieldTypes.PHONE_NUMBER,
        required: false,
        lookupRequired: false,
        key,
        options: [],
      };
    case FieldTypes.DATE:
      return {
        name: 'Date',
        hint: 'Please select a date',
        type: FieldTypes.DATE,
        required: false,
        lookupRequired: false,
        key,
        options: [],
      };
    case FieldTypes.MONEY:
      return {
        name: 'Amount',
        hint: 'Amount to be paid',
        type: FieldTypes.MONEY,
        required: true,
        lookupRequired: false,
        amountType: '',
        key,
        options: [],
      };

    case FieldTypes.LGA:
      return {
        name: 'Local government',
        hint: 'Your local government',
        type: FieldTypes.LGA,
        required: false,
        lookupRequired: false,
        key,
        options: [],
      };
    case FieldTypes.STATE:
      return {
        name: 'State',
        hint: 'Your state',
        type: FieldTypes.STATE,
        required: false,
        lookupRequired: false,
        key,
        options: [],
      };
    case FieldTypes.MULTIPLE_CHOICE:
      return {
        name: 'Multichoice',
        hint: 'Select a value',
        allowMultiSelect: false,
        type: FieldTypes.MULTIPLE_CHOICE,
        required: false,
        lookupRequired: false,
        form: 1,
        values: '',
        key,
        options: [],
      };

    case FieldTypes.DOCUMENT:
      return {
        name: 'Upload Document',
        hint: 'Upload Document',
        type: FieldTypes.DOCUMENT,
        documentTypes: [],
        required: false,
        lookupRequired: false,
        values: '',
        key,
        options: [],
      };

    case FieldTypes.DROP_DOWN:
      return {
        name: 'Drop down',
        hint: 'Select a value',
        multiple: false,
        type: FieldTypes.MULTIPLE_CHOICE,
        required: false,
        lookupRequired: false,
        form: 2,
        values: '',
        key,
        options: {
          option1: { name: '', value: '', key: 'option1' },
          option2: { name: '', value: '', key: 'option2' },
        },
      };

    case FieldTypes.IMAGE:
      return {
        name: 'Upload Image',
        hint: 'Upload Image',
        type: FieldTypes.IMAGE,
        required: false,
        lookupRequired: false,
        key,
        options: [],
      };

    // combined fields

    case FieldTypes.BASIC_DETAILS:
      return {
        [key]: {
          name: 'Name',
          hint: 'Your full name',
          type: FieldTypes.LONG_TEXT,
          required: false,
          lookupRequired: false,
          key,
          options: [],
        },
        [key + 1]: {
          name: 'Phone Number',
          hint: 'Your phone number',
          type: FieldTypes.PHONE_NUMBER,
          selected: FieldTypes.PHONE_NUMBER,
          required: false,
          lookupRequired: false,
          key: key + 1,
          options: [],
        },
        [key + 2]: {
          name: 'Email',
          hint: 'Your email Address',
          type: FieldTypes.LONG_TEXT,
          required: false,
          lookupRequired: false,
          key: key + 2,
          options: [],
        },
      };

    case FieldTypes.EXTRA_DETAILS:
      return {
        [key]: {
          name: 'Address',
          hint: 'Your residential address',
          type: FieldTypes.LONG_TEXT,
          required: false,
          lookupRequired: false,
          key,
          options: [],
        },
        [key + 1]: {
          name: 'Date',
          hint: 'Please select a date',
          type: FieldTypes.DATE,
          required: false,
          lookupRequired: false,
          key: key + 1,
          options: [],
        },
      };

    default:
      break;
  }
};

// export const arrayToObject = (array, key) => {
//   let resultKey = array[key];
//   let result = {};
//   array.forEach((item) => {
//     if (item === undefined) {
//       return;
//     }
//     result[resultKey] = item;
//   });

//   return result;
// };

export const formatStatus = (status) => {
  switch (status) {
    case 'PENDING':
      return 'Pending';
    case 'SUCCESS':
      return 'Success';
    case 'FAILED':
      return 'Failed';
    default:
      return status;
  }
};

export const formatDateForApi = (date) => {
  if (!date) return date;
  return moment(date, 'MMM DD, YYYY').format('YYYY-MM-DD');
};
export const formatDateForApiUtc = (date) => {
  if (!date) return date;
  return `${moment(`${date}`).format('YYYY-MM-DDTHH:mm:ss')}Z`;
};
export const validateEmail = (email) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (re.test(String(email).toLowerCase())) {
    return true;
  }
  return false;
};
export const getStartOfToday = (date = moment()) => {
  const startOfToday = date.startOf('day');
  return moment(startOfToday).format('YYYY-MM-DD HH:mm:ss');
};
export const getEndOfToday = (date = moment()) => {
  const endOfToday = date.endOf('day');
  return moment(endOfToday).format('YYYY-MM-DD HH:mm:ss');
};
export const formatDate = (date) => {
  const momentDate = moment(date) || moment();
  if (!momentDate.isValid()) {
    return '';
  }
  return momentDate.format('YYYY-MM-DD HH:mm:ss');
};

export const getDateFromBeginning = () =>
  moment(1432252800).format('YYYY-MM-DD HH:mm:ss');

export const formatDateForView = (date) => {
  const momentDate = moment(date) || moment();
  if (!momentDate.isValid()) {
    return '';
  }
  return momentDate.format('MMM DD, YYYY');
};
const getFirstDayOfWeek = (date = moment()) => {
  const firstDayOfTheWeek = date.startOf('week');
  return moment(firstDayOfTheWeek).format('YYYY-MM-DD HH:mm:ss');
};

const getLastDayOfWeek = (date = moment()) => {
  const lastDayOfWeek = date.endOf('week');
  return moment(lastDayOfWeek).format('YYYY-MM-DD HH:mm:ss');
};

const getStartOfMonth = (date = moment()) => {
  const startOfMonth = date.startOf('month');
  return moment(startOfMonth).format('YYYY-MM-DD HH:mm:ss');
};

const getEndOfMonth = (date = moment()) => {
  const endOfMonth = date.endOf('month');
  return moment(endOfMonth).format('YYYY-MM-DD HH:mm:ss');
};
export const getDateForToday = () => {
  const today = new Date();
  return moment(today).format('YYYY-MM-DD HH:mm:ss');
};
export const getDateForYesterday = () => {
  const today = new Date();
  const yesterday = today.setDate(today.getDate() - 1);
  return moment(yesterday).format('YYYY-MM-DD HH:mm:ss');
};

export const getFirstDayOfThisWeek = () => getFirstDayOfWeek();

export const getLastDayOfThisWeek = () => getLastDayOfWeek();

export const getFirstDayOfLastWeek = () => {
  const lastWeek = moment().subtract(7, 'days');
  return getFirstDayOfWeek(lastWeek);
};

export const getLastDayOfLastWeek = () => {
  const lastWeek = moment().subtract(7, 'days');
  return getLastDayOfWeek(lastWeek);
};

export const getFirstDayOfThisMonth = () => getStartOfMonth();

export const getEndOfThisMonth = () => getEndOfMonth();

export const getStartOfLast3Month = () => {
  const threeMonthsBefore = moment().subtract(3, 'month');
  return getStartOfMonth(threeMonthsBefore);
};

export const getEndOfLast3Month = () => getEndOfMonth();

export const getFirstDayOfThisQuarter = () => {
  const firstDayOfQuarter = moment().quarter(0).startOf('quarter');
  return moment(firstDayOfQuarter).format('YYYY-MM-DD HH:mm:ss');
};

export const getLastDayOfThisQuarter = () => {
  const lastDayOfThisQuarter = moment().quarter(0).endOf('quarter');
  return moment(lastDayOfThisQuarter).format('YYYY-MM-DD HH:mm:ss');
};

export const getFirstDayOfYear = (date = moment()) => {
  const firstDayOfTheWeek = date.startOf('year');
  return moment(firstDayOfTheWeek).format('YYYY-MM-DD HH:mm:ss');
};

export const getLastDayOfYear = () => {
  const lastDayOfThisQuarter = moment().endOf('year');
  return moment(lastDayOfThisQuarter).format('YYYY-MM-DD HH:mm:ss');
};

export const useQuery = () => new URLSearchParams(useLocation().search);

export const getNgStates = () => {
  const states = NGA_STATE?.map(({ stateName }) => stateName)
    ?.sort()
    ?.map((stateName) => ({
      value: stateName,
      text: stateName,
    }));
  return states;
};

export const getNgLgas = (state) => {
  const selectState =
    NGA_STATE?.find(({ stateName }) => stateName === state) || [];
  const lgas =
    selectState?.lga?.map((item) => ({
      value: item.lga,
      text: item.lga,
    })) || [];

  return lgas;
};

export const getStates = () => {
  const states = NGA_STATE?.map(({ stateName }) => stateName)
    ?.sort()
    ?.map((stateName) => ({
      value: stateName,
      text: stateName,
    }));
  return states;
};

export const getLgas = (state) => {
  const selectState =
    NGA_STATE?.find(({ stateName }) => stateName === state) || [];
  const lgas =
    selectState?.lga?.map((item) => ({
      value: item.lga,
      text: item.lga,
    })) || [];

  return lgas;
};

export const getInitials = (firstName, lastName) => {
  if (!firstName || !lastName) return '';
  return firstName[0] + lastName[0];
};

export const getGenders = () => [
  {
    value: 'MALE',
    text: 'Male',
  },

  { value: 'FEMALE', text: 'Female' },
];

export const getPathWithoutSlash = (pathname) => {
  const [, path] = pathname.split('/');
  return path;
};

export const statusTextColorMapping = {
  PENDING: { color: 'yellow', text: 'PENDING' },
  PENDING_APPROVAL: { color: 'yellow', text: 'PENDING' },
  SUCCESS: { color: 'green', text: 'SUCCESS' },
  ACTIVE: { color: 'green', text: 'ACTIVE' },
  FAILED: { color: 'red', text: 'FAILED' },
  SUSPENDED: { color: 'red', text: 'SUSPENDED' },
  DELETED: { color: 'red', text: 'DELETED' },
  INSUFFICIENT_FUNDS: { color: 'muted', text: 'INSUFFICIENT FUNDS' },
  INITIATED: { color: 'muted', text: 'INITIATED' },
};

export const AllTransactionTableFilter = {
  id: true,
  terminalId: true,
  productName: true,
  productCode: true,
  amount: true,
  paymentDate: true,
  status: true,
};

export const TransactionTableFilter = {
  id: true,
  productName: true,
  productCode: true,
  amount: true,
  paymentDate: true,
  status: true,
};

export const TerminalTransactionTableFilter = {
  terminalId: true,
  amount: true,
  paymentDate: true,
  status: true,
};

export const getDeviceType = () => {
  const ua = navigator.userAgent;
  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
    return 'tablet';
  }
  if (
    /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
      ua,
    )
  ) {
    return 'mobile';
  }
  return 'desktop';
};
export const getVideoId = (url) => {
  const split = url.split('?v=');
  return split[1];
};

export const publicPaths = new Set([GUIDES, INDEX]);
